var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('bb-footer',{staticClass:"app-footer",attrs:{"condensed":"","disclaimer":_vm.copyright,"contact-links":_vm.contactLinks,"social-links":_vm.socialLinks}})}
var staticRenderFns = []

export { render, staticRenderFns }